import styled from "styled-components";


export const NotificationSettingsHeader = styled.div``

export const NotificationSettingsTitle = styled.h1`
  width: auto;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #002e5c;
  text-transform: capitalize;
  margin: 0;
`;


export const NotificationSettingsCloseBtn = styled.div`
    font-size: 16px;
    cursor: pointer;
    font-family: var(--LayoutNotificationSettingsCloseBtnFont-family);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 15px;
    top: 15px;
`

export const NotificationSettingsContent = styled.div`
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
    background: transparent !important;
    padding: 0 !important;

`

export const NotificationSettingsSwitch = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const NotificationSettingsSwitchLabel = styled.div`
    flex: 30% 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
`;


export const NotificationSettingsHead = styled.div`
  display: flex;
  align-items: center;
`

export const NotificationSettingsHeadLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  width: 80px;
`

export const NotificationSettingsContentItem = styled.div``;
export const NotificationSettingsContentItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const NotificationSettingsContentItemName = styled.div`
  flex: 1;
`;
export const NotificationSettingsContentItemBox = styled.div`
 width: 80px;
`;
